import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { TransferInformationComponent } from '@components/TransferInformation/TransferInformation.component';
import { IFunctionAbility } from '@models/users';
import { CommonService } from '@services/common-service';
import { DebounceService } from '@services/debounce.service';
import { ToastService } from '@services/toastService/toastMessage.service';
import { Subject } from 'rxjs';
import { debounceTime, filter, takeUntil } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';

type StoryParams = {
  contentType: 'Story',
  startIndex: number,
  endIndex: number,
  sortField: string,
  sortOrder: string,
  topicsInfo: boolean
};

@Component({
    selector: 'app-move-post-modal',
    templateUrl: './move-post.component.html',
    styleUrls: ['./move-post.component.scss']
    // see styles/ng-zorro/nz-modal.scss for global styles
    ,
    standalone: false
})
export class MovePostModalComponent implements OnInit, OnChanges {

  @Input() isMovePostVisible;

  @Input() StoryList;

  @Input() sourcePostId;

  @Input() isPinnedOnTop;

  @Output() closeMovePost: EventEmitter<any> = new EventEmitter<any>();

  @Output() updatedStories: EventEmitter<any> = new EventEmitter<any>();

  destinationStory = '';

  value = '';

  movePostApi;

  getStoryTitlesAPI;

  listofStories = [];

  emptyStories = ['No Stories Found'];

  filteredOptions: string[] = [];

  filteredOptionsInit: any[];

  storySearchSubject: Subject<string> = new Subject();

  currentStories: any;

  deletedRelatedStories: any = [];

  isLoaded = true;

  searchText: string = '';

  previousSearchText: string = '';

  public functionAbility = {} as IFunctionAbility;

  isScrollLoaded: boolean = true;

  // Cancel API request
  cancelRequest: Subject<boolean> = new Subject<boolean>();

  page: number = 1;

  limit: number = 50;

  total: number = 0;

  constructor(
    private cService: CommonService,
    private toastService: ToastService,
    private tI: TransferInformationComponent,
    private debounceService: DebounceService,
  ) { }


  ngOnInit() {

    this.movePostApi = environment.getPostApi;
    this.getStoryTitlesAPI = environment.globalSearch;
    this.tI.getUserFunctionAbility().subscribe(userAccess => {

      this.functionAbility = userAccess;

    });


    this.storySearchSubject.pipe(debounceTime(700)).subscribe(() => {

      this.handleSearchRequest()

    });

  }

  ngOnChanges() {

    console.log('Related stories', this.currentStories, this.StoryList);
    this.StoryList = this.StoryList.map((story) => {

      story.isPinnedOnTop = this.isPinnedOnTop;
      return story;

    });
    this.currentStories = JSON.parse(JSON.stringify(this.StoryList));

  }

  handleSearchRequest() {

    try {

      // Empty condition should be handled here because switchmap has to be executed to cancel the previous request
      // Return an observable that emits an empty array if the input is empty

      this.isLoaded = false;

      const queryParams = this.buildParams();

      const queryString = Object.keys(queryParams).map((key: string) => `${key}=${queryParams[key]}`).join('&');

      const params = `?searchString=${this.searchText}&` + queryString;


      this.cService.serviceRequestCommon('post', this.getStoryTitlesAPI, params).pipe(takeUntil(this.cancelRequest.pipe(filter(value => value === true)))).subscribe({

        next: (data: any) => {

          if (!this.isSearchValid()) {
            console.log('Empty search text just after the api call');
            return;
          }

          this.total = data.storyCount;

          const additionalStoriesFromAPI = data.storySearchResult.map((story) => {
            return {
              storyId: story.storyID,
              storyTitle: story.storyTitle,
              storyIdTitle: story.autoGeneratedStoryId ? `${story.autoGeneratedStoryId} | ${story.storyTitle}` : story.storyTitle,
              autoGeneratedStoryId: story.autoGeneratedStoryId,
              storyAccess: story.storyVisibility ? "public" : "private",
              createUserId: story.createUserId,
              isPrimary: false,
              isPinnedOnTop: false
            };
          });

          const additionalStories = JSON.parse(JSON.stringify(additionalStoriesFromAPI));

          this.listofStories = [...this.listofStories, ...additionalStories];
          this.filteredOptions = this.listofStories.length ? this.listofStories.map((story) => story.storyIdTitle) : this.emptyStories;
          this.filteredOptionsInit = this.listofStories.length ? this.listofStories.map((story) => story.storyIdTitle) : this.emptyStories;
        },
        error: (error: any) => {

          console.error('handleSearchRequest', error);
        }
      }).add(() => {

        this.isLoaded = this.isScrollLoaded = true;
      });
    } catch (e) {
      console.error('handleSearchRequest event : ', e);
      this.isLoaded = this.isScrollLoaded = true;
    }
  }


  titleMatch(value) {

    if (this.currentStories.length >= 4) {

      this.toastService.createMessage('warning', 'Maximum Share Limit has been Reached');
      this.value = '';
      return;

    }

    console.log('Titlematch', value);

    //value = value.includes('|') ? value.split('|')[1].trim() : value;

    const availableStory = this.listofStories.filter(story => story.storyIdTitle === value)[0];

    const relatedStory = this.currentStories.filter(story => story.storyIdTitle === value)[0];

    if ((!(availableStory === null || availableStory === undefined) && (relatedStory === null || relatedStory === undefined))) {

      if (!(this.currentStories && this.currentStories.length)) {

        availableStory.isPrimary = true;

      }
      this.currentStories.push(availableStory);
      console.log('Related stories', this.currentStories);
      setTimeout(() => {

        this.value = '';

      }, 100);

    }
    if (this.filteredOptionsInit && this.filteredOptionsInit.length) {

      this.filteredOptions = [...this.filteredOptionsInit];

    }

  }

  getStoryTitlesList(queryStr?: string) {

    let params: string;

    if (queryStr) {

      //params = `?storyTitle=${queryStr}`;
      params = `?searchString=${queryStr}&contentType=Story&startIndex=1&endIndex=50&sortField=modificationDate&sortOrder=descending`;

    } else {

      this.filteredOptions = [];
      return;

    }

    return this.cService.serviceRequestCommon('post', this.getStoryTitlesAPI, params);

  }

  createDeletedStoriesObj() {

    const stories = [];

    this.deletedRelatedStories.forEach((story) => {

      const currentStoryObj = this.currentStories.filter((obj) => obj.storyId === story.storyId)[0];

      const initialStoryObj = this.StoryList.filter((obj) => obj.storyId === story.storyId)[0];

      const deletedStoryObj = this.deletedRelatedStories.filter((obj) => obj.storyId === story.storyId)[0];

      if ((currentStoryObj === null || currentStoryObj === undefined) && !(initialStoryObj === null || initialStoryObj === undefined) &&
        (deletedStoryObj === null || deletedStoryObj === undefined)) {

        stories.push(story);

      } else if ((currentStoryObj === null || currentStoryObj === undefined) && !(initialStoryObj === null || initialStoryObj === undefined)
        && !(deletedStoryObj === null || deletedStoryObj === undefined)) {

        stories.push(deletedStoryObj);

      }

    });
    this.deletedRelatedStories = stories;
    console.log('Final Deleted Array ', this.deletedRelatedStories);

  }

  handleCancel() {

    this.value = '';
    this.filteredOptions = [];

    this.currentStories = JSON.parse(JSON.stringify(this.StoryList));
    this.closeMovePost.emit(true);

  }

  handleOk() {

    // post title and post content need to be passed
    console.log('handleOk : ', this.currentStories);
    if (!(this.currentStories && this.currentStories.length > 0)) {

      this.toastService.createMessage('warning', 'Please select at least one Story');
      return;

    }
    this.createDeletedStoriesObj();
    const queryStr = `/${this.sourcePostId}/` + 'move';

    // tslint:disable-next-line:max-line-length
    const payload = {
      postId: this.sourcePostId,
      relatedStories: this.currentStories,
      deletedRelatedStories: this.deletedRelatedStories,
      isPinnedOnTop: this.isPinnedOnTop
    };

    this.isLoaded = false;
    this.cService.serviceRequestCommon('patch', this.movePostApi, queryStr, payload).subscribe((res: any) => {

      console.log('Response of merge', res);
      this.updatedStories.emit(res.relatedStories);
      this.toastService.createMessage('success', 'Post successfully moved');
      this.closeMovePost.emit(true);

    }, () => {

      this.toastService.createMessage('error', 'Error in saving data. Please try again.');
      this.closeMovePost.emit(true);

    }).add(() => {

      this.value = '';
      this.filteredOptions = [];
      this.isLoaded = true;

    });

  }

  onChange(event: any): void {

    this.searchText = event.target.value;

    if (!this.isSearchValid())
      return;

    console.log('Empty search text in onChange event');

    if (event.key === 'ArrowUp' || event.key === 'ArrowDown' || this.searchText === this.previousSearchText) {
      return;
    }

    this.previousSearchText = this.searchText;

    //Also list must be cleared when there is a new input

    this.listofStories = [];

    this.filteredOptions = [];

    this.filteredOptionsInit = [];

    this.page = 1;

    this.isLoaded = false;

    this.cancelRequest.next(true);

    this.storySearchSubject.next(this.searchText);

  }

  pinStory(storyId, isPinnedOnTop) {

    console.log('pinStory:', { stories: this.currentStories, isPinnedOnTop });

    this.isPinnedOnTop = !isPinnedOnTop;
    this.currentStories = this.currentStories.map(element => {

      element.isPinnedOnTop = this.isPinnedOnTop;
      return element;

    });

  }

  postAsPrimaryStory(storyId) {

    this.currentStories.map((element) => {

      element.isPrimary = element.storyId === storyId;

    });

  }

  deleteRelatedStories(storyindex, storyId) {

    let primaryStoryDeleted = false;

    console.log('deleteRelatedStories : ', storyindex, storyId, this.currentStories);
    this.currentStories.forEach((element, index) => {

      if (storyId === element.storyId) {

        if (element.isPrimary === true) {

          primaryStoryDeleted = true;

        }
        this.currentStories.splice(index, 1);
        this.deletedRelatedStories.push(element);

        // this.addedStories.emit(this.currentStories);

      }

    });

    // If pineed story Deleted make first story as pinned
    if (primaryStoryDeleted && this.currentStories && this.currentStories.length > 0) {

      this.currentStories[0].isPrimary = true;

    }

  }

  onScroll(event: any): void {
    this.debounceService.debounce(() => {
      this.scrollDown(event);
    }, 200);
  }



  scrollDown(event: any) {
    const element = event.target;
    // console.log('scrollHeight in on scroll', element.scrollHeight);
    // console.log('current scrollHeight in on scroll', element.scrollTop);
    if (element.scrollHeight < element.scrollTop + 260) {
      // console.log('Entered Scroll Down');
      this.onScrollDown();
    }
  }


  /**
  * On page scroll, load next page
  *
  */
  onScrollDown() {

    const { end } = this.startEndIndex;

    console.log('onScrollDown (Stories)');

    // If the end index is >= number of results
    if (end >= this.total) {

      console.log('No More Results');
      return;

    }

    if (this.isSearchValid()) {

      this.page += 1;

      this.isScrollLoaded = false;
      this.cancelRequest.next(false);
      this.storySearchSubject.next(this.searchText);
    }

  }

  get startEndIndex(): { start: number, end: number } {

    const end = this.page * this.limit;

    const start = (end - this.limit) + 1;

    return { start, end };

  }

  /**
   * 
   * Build the query string portion of the API call
   */
  buildParams(): StoryParams {

    // API Params
    const params: StoryParams = {
      contentType: 'Story',
      startIndex: 0,
      endIndex: this.limit,
      sortField: 'modificationdate',
      sortOrder: 'descending',
      topicsInfo: true
    };

    try {

      // Page
      const { start: startIndex, end: endIndex } = this.startEndIndex;

      params.startIndex = startIndex;
      params.endIndex = endIndex;

      console.log('buildParams', params);

      return params;

    } catch (error) {

      console.error('buildParams', error);

      return {} as StoryParams;

    }
  }


  isSearchValid() {

    //list of stories must be cleared when the input is empty

    if (this.searchText.trim() === '') {

      this.listofStories = [];

      this.filteredOptions = [];

      this.filteredOptionsInit = [];

      this.previousSearchText = '';

      return false;
    }

    return true;

  }

}
